import {
	initialState,
	RecipeCalculatorBoundariesType,
	RecipesStateType,
	RecipeTooltipVisibilityType,
	RootStateType,
} from '.';

export const getState = (state: RootStateType): RecipesStateType => {
	return state.recipes || initialState;
};

export const getSelectedPortion = (state: RootStateType, externalId: string): number =>
	getState(state).portionSelectorState[externalId] || 0;

export const getVariantList = (state: RootStateType, externalId: string): number[] =>
	getState(state).portionVariationList[externalId] || [];

export const getTooltipVisibility = (state: RootStateType, externalId: string): RecipeTooltipVisibilityType => {
	const variantList = getVariantList(state, externalId);
	const selectedPortion = getSelectedPortion(state, externalId);
	const selectedPortionIndex = variantList.indexOf(selectedPortion);
	const variantSize = variantList.length;

	return {
		increment: Boolean(selectedPortionIndex + 1 < variantSize),
		decrement: Boolean(selectedPortionIndex === 0),
	};
};

export const getDirectionBoundaries = (state: RootStateType, externalId: string): RecipeCalculatorBoundariesType => {
	const variantList = getVariantList(state, externalId);
	const selectedPortion = getSelectedPortion(state, externalId);

	let increment: boolean = true;
	let decrement: boolean = true;

	const indexOfCurrentVariant = variantList.indexOf(selectedPortion);

	if (indexOfCurrentVariant === 0) {
		decrement = false;
	} else if (indexOfCurrentVariant === variantList.length - 1) {
		increment = false;
	}

	return {
		decrement,
		increment,
	};
};
